import * as React from 'react'

export const StageStart = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={81}
    fill="none"
    {...props}
  >
    <g filter="url(#a)">
      <path
        fill="#FBFBFB"
        d="M33.067 8.661a5.6 5.6 0 0 1 5.666 0l22.112 12.966a5.6 5.6 0 0 1 2.768 4.831v26.084a5.6 5.6 0 0 1-2.768 4.83L38.733 70.34a5.6 5.6 0 0 1-5.666 0L10.955 57.373a5.6 5.6 0 0 1-2.768-4.831V26.458a5.6 5.6 0 0 1 2.768-4.83L33.067 8.66Z"
      />
      <path
        fill="#1CB630"
        d="M33.09 15.62a5.6 5.6 0 0 1 5.62 0L55.4 25.3a5.6 5.6 0 0 1 2.79 4.845v19.409a5.6 5.6 0 0 1-2.79 4.844L38.71 64.08a5.6 5.6 0 0 1-5.62 0L16.4 54.398a5.6 5.6 0 0 1-2.79-4.844v-19.41a5.6 5.6 0 0 1 2.79-4.843l16.69-9.682Z"
      />
      <g filter="url(#b)">
        <path
          fill="#FAFCE6"
          d="M41.11 31.328 51.9 33.69l-7.357 8.327 1.113 11.11-10.104-4.502-10.104 4.503 1.113-11.11-7.357-8.328 10.791-2.363 5.557-9.65 5.558 9.65Z"
        />
      </g>
    </g>
    <defs>
      <filter
        id="a"
        width={80}
        height={81}
        x={-4.1}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.197115 0 0 0 0 0.00379068 0 0 0 0 0.119786 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12627"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12627"
          result="shape"
        />
      </filter>
      <filter
        id="b"
        width={32.696}
        height={33.023}
        x={19.204}
        y={21.677}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.572} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12627"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12627"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
